export const COLORS = {
  primary: '#022673',
  white: '#ffffff',
  lightGray: '#f5f5f5',
  mediumGray: '#9e9e9e',
  darkGray: '#424242',
  borderGray: '#e0e0e0',
  dividerGray: '#bdbdbd',
  textGray: '#666',

  selected: 'rgba(33, 150, 243, 0.08)',
  selectedHover: 'rgba(33, 150, 243, 0.12)',
  selectedLight: '#eef7fe',
  selectedLightHover: '#e4f2fe',

  blocked: 'rgba(158, 158, 158, 0.45)',
  deleted: 'rgba(158, 158, 158, 0.3)',
  deletedCell: 'rgba(158, 158, 158, 0.2)',
  deletedDark: '#d4d4d4',

  dateChanged: 'rgba(255, 235, 59, 0.15)',
  dateChangedBg: '#ffe0b3',
  dateChangedHover: '#ffd699',
  dateChangedAcceptedBg: '#FFF0DB',
  dateChangedAcceptedBgHover: '#FFE6C2',
  dateChangedWarning: '#ff9800',
  dateChangedWarningHover: '#f57c00',
  dateChangedAcceptedWarning: '#ffcc80',
  dateChangedAcceptedWarningHover: '#ffb74d',

  shippingLineHaulageBg: '#D4DDE6',
  shippingLineHaulageHover: '#B3C2D1',

  success: '#4caf50',
  error: '#d32f2f',
  errorLight: '#f44336',
  loading: '#9e9e9e',
  warning: '#ff9800',

  rowHover: 'rgba(0, 0, 0, 0.05)',
  columnHover: '#f5f5f5',
  iconHover: 'rgba(0, 0, 0, 0.9)',
} as const;

export const TIMINGS = {
  transitionFast: '0.1s',
  transitionMedium: '0.15s',
  transitionNormal: '0.3s',
  transitionSlow: '1s',
  animationPulse: '1.5s',
} as const;

export const SHADOWS = {
  table: '0 0 4px rgba(0, 0, 0, 0.15)',
  checkbox: '2px 0 4px rgba(0, 0, 0, 0.05)',
  icon: '0 2px 4px rgba(0, 0, 0, 0.2)',
  border: (color: string) => `inset 0 0 0 2px ${color}`,
  borderWithGlow: (color: string, glowColor: string) =>
    `inset 0 0 0 2px ${color}, 0 0 0 3px ${glowColor}`,
  borderThin: (color: string) => `inset 0 0 0 1px ${color}`,
  borderThinWithGlow: (color: string, glowColor: string) =>
    `inset 0 0 0 1px ${color}, 0 0 0 1px ${glowColor}`,
} as const;

export const SIZES = {
  separatorHeight: '28%',
  separatorWidth: '2px',
} as const;
